// @ts-check
import { useCallback } from 'react';
import { encodeQuery, urlJoin } from '@zedoc/url';
import settings from '../common/settings';

const { backendUrl = '' } = /** @type {{ backendUrl?: string}} */ (
  settings.public || {}
);

/**
 * @param {string} url
 * @param {string} [name]
 */
export function download(url, name) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener';
  if (name) {
    link.download = name;
  }
  link.click();
}

export default function useDownload() {
  return useCallback(
    /**
     * @template [T=undefined]
     * @param {string} path
     * @param {object} [options]
     * @param {string} [options.name]
     * @param {Record<string, string>} [options.query]
     * @param {(url: string) => T} [options.onDownload]
     * @returns {T | undefined}
     */
    (path, options = {}) => {
      const { name, query, onDownload } = options;
      const url = `${urlJoin(backendUrl, path)}${
        query ? encodeQuery(query) : ''
      }`;
      if (!onDownload) {
        download(url, name);
        return undefined;
      }
      return onDownload(url);
    },
    [],
  );
}
